import { render } from "./ContactModal.vue?vue&type=template&id=529fe774&scoped=true"
import script from "./ContactModal.vue?vue&type=script&lang=js"
export * from "./ContactModal.vue?vue&type=script&lang=js"

import "./ContactModal.vue?vue&type=style&index=0&id=529fe774&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-529fe774"

export default script